import styles from "./Spinner.module.css";

interface SpinnerProps {
  size?: number;
  /** Stroke colour; defaults to currentColor so it inherits the button text. */
  color?: string;
  label?: string;
}

export function Spinner({ size = 16, color = "currentColor", label }: SpinnerProps) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size, color }}
      role="status"
      aria-label={label ?? "Loading"}
    >
      <svg viewBox="0 0 24 24" width={size} height={size} fill="none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.4" opacity="0.2" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
